<template>
  <div>
    <nav>
      <div class="titleRRIM">
        <a class="buttonBack" value="menuSistemas" :href="systemUserUrl" >
        </a>
        <h4 class="title">Relatório de Recebimento e Introdução do Molde</h4>
      </div>

      <div style="display: flex; align-items: center">
        <span style="font-size: 0.6rem">Versão 1.0.1</span>
        <button @click="menu">
          <img src="../../../../public/img/iconMenu.svg" alt="menu" />
        </button>
      </div>
    </nav>

    <div class="noTransitionMenu" :class="{ transitionMenu }">
      <div class="heightAdmin">
        <div class="cardAdmin">
          <div class="menuAdmin">
            <div class="adminReport">
              <h3>Sistemas</h3>
              <ul>
                <li
                  v-for="system in accessibleSystems"
                  :key="system.id || system.url"
                >
                  <a :href="system.url" target="_blank">
                    {{ system.description }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="adminUser">
              <h3>Informações do usuário</h3>
              <p>
                <strong>Nome:</strong>
                {{ $store.state.user.nome_completo }}
              </p>
              <p>
                <strong>Matricula:</strong>
                {{ $store.state.user.matricula }}
              </p>
              <p>
                <strong>Email:</strong>
                {{ $store.state.user.email }}
              </p>
              <p>
                <strong>Cargo:</strong>
                {{ $store.state.user.cargo.descricao }}
              </p>
              <p>
                <strong>Nível de Acesso:</strong>
                {{ $store.state.user.nivel_de_acesso.descricao }}
              </p>

              <!-- <button style="padding: 10px; border-radius: 4px" @click="showChange">
                Trocar Senha
              </button> -->
            </div>
            <ChangePassword
              v-if="showPassword"
              @showChangePassword="showChangePassword"
            />
          </div>
          <div class="containerExit">
            <div class="logout" @click="logout">
              <p>Sair</p>
              <!-- <img :src="iconExit" alt="" /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const systemUrls = {
  RRIM: process.env.VITE_RRIM_URL,
  TRYOUT: process.env.VITE_SOL_TRYOUT_MAO,
  "REL. TRYOUT": process.env.VITE_REL_TRYOUT,
  FTI: process.env.VITE_FTI_URL,
  FIT: process.env.VITE_FIT_URL,
  "MATRIZ DE VERSATILIDADE": process.env.VITE_MATRIZ_VERSATILIDADE,
  RGM: process.env.VITE_FRONT_RGM,
  RIA: process.env.VITE_RIA_MAO,
  FTA: process.env.VITE_FTA_MAO,
  FASEUM: process.env.VITE_FASEUM_MAO,
};

export default {
  data() {
    return {
      transitionMenu: false,
      showPassword: false,
      systemUserUrl: process.env.VITE_SYSTEM_USER_FRONT,
    };
  },
  computed: {
    accessibleSystems() {
      const userSystems = this.$store.state.user.User_Sistema;

      if (!Array.isArray(userSystems)) {
        return [];
      }

      return userSystems
        .map(({ sistema }) => {
          if (!sistema) {
            return null;
          }

          return {
            id: sistema.id,
            description: sistema.descricao,
            url: systemUrls[sistema.descricao.trim().toUpperCase()],
          };
        })
        .filter((system) => system && system.description && system.url);
    },
  },
  methods: {
    menu() {
      this.transitionMenu = !this.transitionMenu;
    },
    showChange() {
      this.showPassword = !this.showPassword;
    },
    logout() {
      document.cookie = 'auth._token.local=false;path=/; domain=.tutilabs.com.br'
      document.cookie = 'auth._token_expiration.local=false;path=/; domain=.tutilabs.com.br'
      window.location.replace(this.systemUserUrl)
    },
    showChangePassword() {
      this.showPassword = false;
    },
  },
};
</script>

<style scoped>
nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 var(--negativeSpace);
  width: 100%;
  height: 7vh;
  position: fixed;
  top: 0;
  z-index: 9;
  background: var(--green);
  gap: 0.5rem;
}

nav div {
  display: flex;
  gap: 1rem;
  color: var(--white);
}

nav button {
  background: none;
  border: none;
}

nav button img {
  transition: 0.5s;
}

img:hover {
  transform: rotate(225deg);
}
.buttonBack{
    width: 2.5rem;
    height: 2rem;
    background: url("../../../static/icons/home.png");
    background-repeat: no-repeat;
  }
.noTransitionMenu.transitionMenu {
  width: 100%;
  transition: 1.2s;
  margin-top: 5vh;
  background: rgba(149, 164, 167, 0.178);
  backdrop-filter: blur(15px);
  z-index: 3;
}

.noTransitionMenu {
  display: flex;
  width: 100%;
  transition: 1.2s;
  background: rgba(149, 164, 167, 0.178);
  backdrop-filter: blur(15px);
  margin-top: -100vh;
  position: fixed;
  z-index: 3;
}

.heightAdmin {
  height: 100vh;
  width: 100%;
}

.cardAdmin {
  width: 100%;
  position: relative;
  background-color: var(--white);
}

.menuAdmin {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: 5fr 1fr;
  padding: 2rem;
  gap: 2rem;
}

/* @media (max-width: 531px) {
  grid-template-columns: 1fr;
} */

.adminOption .icons {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.adminOption .icons .icon {
  display: flex;
  align-items: center;
  gap: 2rem;
  color: var(--blue_base);
}

.adminOption .icons .icon img {
  width: 30px;
  height: 30px;
}



.adminReport,
.adminOption {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  border-right: 1px solid var(--gray);
  padding: 0 1rem;
}

ul {
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  font-weight: 500;
  list-style: none;
}

ul li {
  width: 100%;
  display: flex;
  /* // border-bottom: 1px solid var(--gray); */
  padding: 0.8rem 0;
}

ul li a {
  width: 100%;
  color: var(--blue_base);
  transition: 0.1s;
}

ul li a:hover {
  font-weight: 600;
}

ul li p {
  color: var(--blue_base);
  cursor: pointer;
  width: 100%;
}

.containerExit {
  width: 100%;
  display: flex;
  justify-content: end;
  border-top: 1px solid var(--gray);
  padding: 1rem;
}

.containerExit .logout {
  position: relative;
  right: 6rem;
  display: flex;
  gap: 0.7rem;
  cursor: pointer;
}

.containerExit .logout p {
  color: #18a0fb;
  font-weight: bold;
}
.containerExit .logout img {
  width: 2rem;
}

.adminUser p{
  margin-top: 10px;
}

@media (max-width: 425px) {
  .titleRRIM {
    width: 100%;
  }

  .titleRRIM h3 {
    font-size: 1rem;
  }


  .menuAdmin {
    gap: 0;
    padding: 0.5rem;
    overflow: scroll;
    justify-items: center;
  }

  .adminOption,
  .adminReport {
    align-items: center;
  }

  .adminUser {
    padding: 0 1rem;
  }
 

  .adminOption .icons {
    grid-template-columns: 1fr;
  }

  .adminOption .icons .icon {
    gap: 0.5rem;
  }
}
</style>
